export default __webpack_public_path__ + "static/media/02.04.170.73e18ac6.png";